import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const login = async (email, password,role) => {
  try {
    const response = await axios.post(`${BACKEND}/auth/login`, { email, password,role });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : { message: 'An error occurred' };
  }
};

export const signUp = async (name, email, phone, password, role) => {
    try {
      const response = await axios.post(`${BACKEND}/auth/signup`, {
        name,
        email,
        phone,
        password,
        role,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'An error occurred' };
    }
  };
